module.exports = __webpack_public_path__ + "img/GAME_MULTI GOSTOP1.5cf82bd7.jpg";